module.exports = __webpack_public_path__ + "img/whyBlue.c79ab3a7.jpg";